import React from 'react';
import Editor from '@monaco-editor/react';
import { Box, useTheme } from '@mui/material';

const LINE_HEIGHT = 19;
const CHROME_HEIGHT = 16;     // top/bottom padding Monaco reserves regardless of content

// A JSON viewer in Monaco, the VS Code editor, as in ves-web: real fold gutters, syntax colours and search (Ctrl+F inside
// the editor). @monaco-editor/react loads Monaco from its CDN, so nothing is bundled. `value` is the JSON text. Read only unless
// `onChange` is given, which is then called with the new text; an editable one is at least `minHeight` high so there is room to type.
export default function JsonEditor({ value, onChange, label = 'JSON', maxHeight = 600, minHeight = 120 }) {
  const theme = useTheme();
  const lines = String(value).split('\n').length;
  const height = Math.min(maxHeight, Math.max(minHeight, lines * LINE_HEIGHT + CHROME_HEIGHT));
  return (
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, overflow: 'hidden' }}>
      <Editor
        height={height}
        language="json"
        theme={theme.palette.mode === 'dark' ? 'vs-dark' : 'light'}
        value={String(value)}
        onChange={onChange ? (text) => onChange(text || '') : undefined}
        options={{
          ariaLabel: label,
          readOnly: !onChange,
          domReadOnly: !onChange,
          minimap: { enabled: false },
          folding: true,
          showFoldingControls: 'always',     // the default shows the arrows only on hover, which is easy to miss
          lineNumbers: 'on',
          scrollBeyondLastLine: false,
          fontSize: 12.5,
          renderLineHighlight: 'none',
          wordWrap: 'on',
          automaticLayout: true,
          overviewRulerLanes: 0,
          hideCursorInOverviewRuler: true,
          scrollbar: { alwaysConsumeMouseWheel: false },
        }}
      />
    </Box>
  );
}
